import React from 'react';
import styles from './copyright.module.css'; // Skapa en CSS-fil för stilar

const Copyright = () => {
  return (
    <footer className={styles.footer}>
      <p>&copy; {new Date().getFullYear()} HealthWeek Website Builder by Baraa. All rights reserved</p>
    </footer>
  );
};

export default Copyright;